<template>
    <!-- begin panel -->
    <panel no-button="true" title="Edit storyboard">
        <p v-if="errors.length">Please correct the following error(s): </p>
        <ul>
            <li v-for="error in errors" :key="error" style="color: red"> {{ error}} </li>
        </ul>
        <form v-if="storyboard">
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Storyboard name</label>
                <div class="col-md-9">
                    <input v-model="name" type="text" class="form-control m-b-5" placeholder="Enter storyboard name" />
                </div>
            </div>
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Description</label>
                <div class="col-md-9">
                    <textarea v-model="description" class="form-control" rows="3"></textarea>
                </div>
            </div>
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Insights</label>
                <div class="col-md-9">
                    <textarea v-model="insights" class="form-control" rows="3"></textarea>
                </div>
            </div>
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Target outcome</label>
                <div class="col-md-9">
                    <textarea v-model="target" class="form-control" rows="3"></textarea>
                </div>
            </div>
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Responsible person</label>
                <div class="col-md-9">
                    <input v-model="responsiblePerson" type="text" class="form-control m-b-5" placeholder="Enter name" />
                </div>
            </div>
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Production budget</label>
                <div class="col-md-9">
                    <input v-model="budget" type="number" min="0" class="form-control m-b-5" placeholder="Enter estimated budget" />
                </div>
            </div>
            <div v-for="(note, index) in notes" :key="note.value" class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Note #{{ index+1 }}</label>
                <div class="col-md-8">
                    <textarea v-model="note.content" class="form-control" rows="3" />
                </div>
                <div class="col-md-1">
                    <input-button type="button" label="Remove" @click="removeNote(index)" class="btn-danger pull-right" />
                </div>
            </div>
            <div class="form-group row m-b-15">
                <div class="col-md-11"/>
                <div class="col-md-1">
                    <input-button type="button" label="Add note" @click="addNote" class="btn-inverse pull-right" />
                </div>
            </div>
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Image</label>
                <div class="col-md-9">
                    <vue-dropzone ref="imageDropzone" id="imageDropzone" :options="imageDropzoneOptions" @vdropzone-removed-file="imageRemoved" @vdropzone-success="imageSuccess" />
                    <b-button variant="yellow" class="mt-2" @click="openImageLibrary">Choose from library</b-button>
                </div>
            </div>
            <div class="form-group row m-b-15">
                <label class="col-form-label col-md-3">Files</label>
                <vue-dropzone class="col-md-9" ref="filesDropzone" id="filesDropzone" :options="filesDropzoneOptions" @vdropzone-removed-file="fileRemoved" @vdropzone-success="fileSuccess" />
            </div>
        </form>

        <hr />

        <b-button variant="secondary" @click="cancel">Cancel</b-button>
        <input-button type="submit" label="Save" @click="validate" class="btn-yellow pull-right" />
        <input-button type="button" class="btn-danger pull-right" label="Delete" @click="deleteStoryboard" />
    
        <image-library-modal ref="childModal" />
    </panel>
    <!-- end panel -->
</template>

<script>
import InputButton from '../../components/buttons/InputButton.vue'
import ImageLibraryModal from '../image-library/ImageLibraryModal.vue'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { authHeader } from '../../helpers'

export default {
    name: 'StoryboardEdit',
    props: ['storyboard'],
    components: {
        InputButton,
        ImageLibraryModal,
        VueDropzone: vue2Dropzone
    },
    data() {
        return {
            errors: [],
            name: null,
            description: '',
            insights: '',
            target: '',
            responsiblePerson: '',
            budget: 0,
            notes: [],
            imageId: null,
            fileIds: [],
            imageChanged: false,
            filesChanged: false,
            dropzoneArray: [],
            imageDropzoneOptions: {
                url: process.env.VUE_APP_API_URL + '/image',
                thumbnailWidth: 175,
                addRemoveLinks: true,
                maxFiles: 1,
                maxFilesize: 2,
                acceptedFiles: 'image/jpg, image/jpeg, image/png',
                dictDefaultMessage: 'Drop an image here to upload',
                headers: authHeader()
            },
            filesDropzoneOptions: {
                url: process.env.VUE_APP_API_URL + '/file',
                thumbnailWidth: 175,
                addRemoveLinks: true,
                maxFilesize: 5,
                acceptedFiles: 'application/pdf, image/jpg, image/jpeg',
                dictDefaultMessage: 'Drop files here or click to upload',
                headers: authHeader()
            },
            isDestroying: false
        }
    },
    methods: {
        validate() {
            if (this.description == null) {
                this.description = "";
            }
            if (this.insights == null) {
                this.insights = "";
            }
            if (this.target == null) {
                this.target = "";
            }
            if (this.responsiblePerson == null) {
                this.responsiblePerson = "";
            }
            if (this.budget == null) {
                this.budget = 0;
            }

            if (this.name) {
                this.submit();
            }

            this.errors = [];

            if (!this.name) {
                this.errors.push("Name required!");
            }
        },
        submit() {
            this.notes.forEach(note => {
                if (note.id) {
                    this.$parent.submitNote(note.id, JSON.stringify({
                        content: note.content
                    }));
                } else {
                    this.$parent.createNoteCall(JSON.stringify({
                        content: note.content,
                        storyboardId: this.storyboard.id
                    }));
                }
            });
            this.$parent.update(this.storyboard.id, JSON.stringify({
                name: this.name,
                description: this.description,
                insights: this.insights,
                target: this.target,
                responsiblePerson: this.responsiblePerson,
                budget: this.budget,
                imageId: this.imageId,
                fileIds: this.fileIds
            }));
        },
        deleteStoryboard() {
            if (confirm("Are you sure you want to delete " + this.storyboard.name + "?")) {
                this.$parent.delete(this.storyboard.id);
            }
        },
        addNote() {
            this.noteIndex++;
            this.notes.push( {value: '' })
        },
        removeNote(index) {
            if (confirm("Are you sure you want to delete Note #" + (index + 1) + "?")) {
                if (this.notes[index].id) {
                    this.$parent.deleteNoteCall(this.notes[index].id)
                }
                this.notes.splice(index, 1);
            }
        },
        imageRemoved() {
            if (!this.isDestroying) {
                this.$parent.removeImage(this.imageId);
                this.imageId = null;
            }
        },
        imageSuccess(imageFile, image) {
            this.imageId = image.id;
            this.imageChanged = true;
        },
        imageSelected(image) {
            this.$refs.imageDropzone.removeAllFiles();
            this.imageId = image.id;

            let mockFile = {
                id: this.imageId,
                size: 175,
                url: process.env.VUE_APP_API_URL + '/uploads/images/' + image.imageFd
            }
            this.$refs.imageDropzone.manuallyAddFile(mockFile, mockFile.url);
        },
        openImageLibrary() {
            this.$refs['childModal'].$refs['modalImageLibrary'].show();
        },
        cancel() {
            if (this.imageChanged) {
                this.$parent.removeImage(this.imageId);
            }
            if (this.filesChanged) {
                this.fileIds.forEach(fileId => {
                    this.$parent.removeFile(fileId);
                });
            }
            this.$router.push(`/storyboard/${this.$route.params.id}`);
        },
        fileRemoved(file) {
            if (!this.isDestroying) {
                let index = 0;
                this.dropzoneArray.forEach(function(obj, objIndex) {
                    if (file.upload) {
                        if (file.upload.uuid == obj.upload.uuid) {
                            index = objIndex;
                        }
                    } else {
                        if (file.url == obj.url) {
                            index = objIndex;
                        }
                    }
                });
                this.dropzoneArray = this.$refs.filesDropzone.dropzone.files;
                this.$parent.removeFile(this.fileIds[index]);
                this.fileIds.splice(index, 1);
            }
        },
        fileSuccess(fileFile, file) {
            this.fileIds.push(file.id);
            this.dropzoneArray = this.$refs.filesDropzone.dropzone.files;
            this.filesChanged = true;
        },
    },
    beforeDestroy() {
        this.isDestroying = true;
    },
    updated() {
        if (this.name === null) {
            this.name = this.storyboard.name
            this.description = this.storyboard.description
            this.insights = this.storyboard.insights
            this.target = this.storyboard.target
            this.responsiblePerson = this.storyboard.responsiblePerson
            this.budget = this.storyboard.budget
            this.notes = this.storyboard.notes
            if (this.storyboard.image != null) {
                this.imageId = this.storyboard.image.id
            
                let mockFile = {
                    id: this.storyboard.image.id,
                    size: 175,
                    url: process.env.VUE_APP_API_URL + '/uploads/images/' + this.storyboard.image.imageFd
                }
                
                if (mockFile.id != null) {
                    this.$refs.imageDropzone.manuallyAddFile(mockFile, mockFile.url);
                }
            }
            if (this.storyboard.files.length > 0) {
                this.fileIds = [];
                this.storyboard.files.forEach(file => {
                    this.fileIds.push(file.id);

                    let mockFile = {
                        id: file.id,
                        size: 175,
                        url: process.env.VUE_APP_API_URL + '/uploads/files/' + file.fileFd
                    }

                    if (mockFile.id != null) {
                        this.$refs.filesDropzone.manuallyAddFile(mockFile, mockFile.url);
                    }
                });
                this.dropzoneArray = this.$refs.filesDropzone.dropzone.files;
            }
        }
    }
}
</script>